import React, { useEffect, useRef, useState } from 'react';
import './DentalExpertiseTwo.css';
import dentalexpert from "./assets/DentalExpertise.jpeg";

const DentalExpertiseTwo = () => {
    const [scrollY, setScrollY] = useState(0);
    const textContentRef = useRef(null);
    const imageRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Calculate parallax effect for text content (top to bottom motion)
    const textTransform = `translateY(${scrollY * 0.05}px)`;
    const imageTransform = `translateY(${scrollY * 0.05}px)`;

    return (
        <div className="expertise-container-two">
            <div className="expertise-wrapper-two">

                {/* left Side - Text Content with top-to-bottom motion */}
                <div
                    className="expertise-content-two"
                    ref={textContentRef}
                    style={{ transform: textTransform }}
                >
                    <div className="content-inner-two">
                        <div className="section-label-two">
                            <span className="label-line-two"></span>
                            <span className="label-text-two">Your Privacy Matters</span>
                        </div>

                        <h1 className="expertise-title-two">
                            Our Privacy Commitment
                        </h1>

                        <div className='other-content-two'>

                            <div className="expertise-description-two">
                                <p>
                                    We are committed to protecting your personal information. Our website operates without tracking cookies, analytics, or data collection forms that compromise your privacy.
                                </p>
                                <p>
                                    You can browse freely knowing that no personal data is being collected, stored, or shared with third parties. Your trust is our priority.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>

                {/* right Side - Image with motion effect */}
                <div
                    className="expertise-image-two"
                    ref={imageRef}
                    style={{ transform: imageTransform }}
                >
                    <div className="image-overlay-two"></div>
                    <img src={dentalexpert} alt="Privacy Focused Environment" className="doctor-image-two" />
                    {/*                     
            <img 
                src="/assets/dr-jesse-jackson.jpg" 
                alt="Dr. Jesse Jackson - Excellence in Full-Arch Implant Dentistry"
                className="doctor-image"
            />
*/}
                    <div className="image-badge-two">
                        <span>Zero Data Collection</span>
                    </div>
                </div>
            </div>

            {/* Decorative elements */}
            <div className="deco-circle-two deco-1-two"></div>
            <div className="deco-circle-two deco-2-two"></div>
            <div className="deco-dots-two"></div>
        </div>
    );
};

export default DentalExpertiseTwo;